// import getCookieDomain from '@/libs/domain/getCookieDomain';
import router from '@/router/index';
import store from '@/store/index';
// import Cookie from 'js-cookie';

export default function handleToken(response: any): any {
    if (response.status === 401) {
        store.state.access_token = null;
        // Cookie.remove('access_token', { domain: getCookieDomain() });
        localStorage.removeItem('access_token');
        router.replace('/auth')
        return {
            data: response.data,
            status: response.status
        };
    } else {
        return {
            data: response.data,
            status: response.status
        };
    }
}
